import React, { useContext, useState, Fragment } from 'react';
import { AlignCenter } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image, UL } from '../../../AbstractElements';
import CheckContext from '../../../_helper/Customizer';
import CustomizerContext from '../../../_helper/Customizer';
import DollarSign from '../../../assets/images/ui/dollar.png';

const MainMenu = () => {
    const { sidebarResponsive } = useContext(CustomizerContext);
    const { toggleSidebar } = useContext(CheckContext);
    const [toggle, setToggle] = useState(true);

    const openCloseSidebar = () => {
        setToggle(!toggle);
        toggleSidebar(toggle);
    };

    return (
        <Fragment>
            <div className="main-menu">
                <div className="logo-wrapper">

                    {/* Logo → Home */}
                    <Link to="/">
                        <Image
                            attrImage={{
                                className: 'img-fluid d-inline',
                                src: require('../../../assets/images/logo/maxpark-logo-white@2x-50.png'),
                                alt: 'Max Park'
                            }}
                        />
                    </Link>

                </div>

                <div className="nav-right col pull-right right-menu p-0">
                    <UL
                        attrUL={{
                            className: `simple-list d-flex flex-row nav-menus ${
                                sidebarResponsive ? 'open' : ''
                            }`
                        }}
                    >
                        <nav className="navbar navbar-light p-0" id="navbar-example2">
                            <ul className="landing-menu nav nav-pills client-menu">

                                {/* Home */}
                                <li className="nav-item">
                                    <Link to="/" className="nav-link">
                                        Accueil
                                    </Link>
                                </li>

                                {/* Search / Pay Ticket */}
                                <li className="nav-item">
                                    <img
                                        src={DollarSign}
                                        className="p-absolute top-15"
                                        alt="dollars"
                                    />

                                    <Link
                                        to="/recherche"
                                        className="nav-link m-l-10 right-85p"
                                    >
                                        Payer un avis
                                    </Link>
                                </li>

                                {/* Services */}
                                <li className="nav-item">
                                    <Link
                                        to="/services"
                                        className="nav-link"
                                    >
                                        Services
                                    </Link>
                                </li>

                                {/* Contact */}
                                <li className="nav-item">
                                    <Link
                                        to="/contact"
                                        className="nav-link"
                                    >
                                        Contact
                                    </Link>
                                </li>

                            </ul>
                        </nav>
                    </UL>
                </div>

                <div className="toggle-sidebar" onClick={openCloseSidebar}>
                    <AlignCenter
                        className="status_toggle middle"
                        id="sidebar-toggle"
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default MainMenu;